export enum CurrencyEnum {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  BGN = 'BGN',
}

export enum CurrencySymbolEnum {
  EURO='€',
  USD='$',
  BGN='BGN '
}

export enum NumberSignEnum {
  Positive='+',
  Negative='-'
}
